import  { useState, useCallback } from 'react';

/*export const APIErrorContext = React.createContext({
    error: null,
    addError: () => {},
    removeError: () => {}
});*/

const NotificationService = () => {
    const [notice, setNotice] = useState(null);

    const removeError = () => setNotice(null);

    const addNotice = (message, status) => {
        setNotice({ message, status });
    }
    return {
        notice: notice,
        addNotice: useCallback((message, status) => addNotice(message, status), []),
        removeNotice: useCallback(() => removeError(), [])
    };

}

export default NotificationService;
